import { render, staticRenderFns } from "./FormTreeselect.vue?vue&type=template&id=3741e7c8&"
import script from "./FormTreeselect.vue?vue&type=script&lang=ts&"
export * from "./FormTreeselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports